const REDUCER_PATH = "lenderService";
const LENDER_SERVICE_TAG = "Lender";
const LENDER_LOAN_BEST_MATCH_HEATMAP_SERVICE_TAG = "LenderLoanBestMatchHeatmap";
const LENDER_LOANS_HEATMAP_SERVICE_TAG = "LenderLoansHeatmap";

const RELATED_TAGS = [LENDER_SERVICE_TAG, LENDER_LOAN_BEST_MATCH_HEATMAP_SERVICE_TAG, LENDER_LOANS_HEATMAP_SERVICE_TAG];

export {
  REDUCER_PATH,
  LENDER_SERVICE_TAG,
  LENDER_LOAN_BEST_MATCH_HEATMAP_SERVICE_TAG,
  LENDER_LOANS_HEATMAP_SERVICE_TAG,
  RELATED_TAGS,
};

